import React, { useEffect, useState } from 'react';
import { MapPin, Clock } from 'lucide-react';
import { campiDaGioco } from '../data/mock';
import { api } from '../api/client';
import { useSiteText } from '../hooks/useSiteText';

export default function CampiSection() {
  const title = useSiteText('home.campi_title', 'Campi da Gioco');
  const subtitle = useSiteText('home.campi_subtitle', "Dal 27 al 31 maggio, le partite fino alla semifinale si disputano nei seguenti campi di gioco di Cava de' Tirreni");
  const note = useSiteText('home.campi_note', 'Gli orari delle partite sono consultabili nella sezione Calendario');

  const [campi, setCampi] = useState(campiDaGioco);
  useEffect(() => {
    let alive = true;
    api.getCampi().then((rows) => {
      if (alive && Array.isArray(rows) && rows.length > 0) setCampi(rows);
    }).catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <section className="py-20 bg-navy">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="section-title centered text-4xl md:text-5xl">{title}</h2>
          {subtitle && <p className="text-white/70 mt-6 max-w-3xl mx-auto">{subtitle}</p>}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {campi.map((c, i) => (
            <div key={c.id || i} className="glass-card p-6 text-center group" style={{ animationDelay: `${i * 100}ms` }}>
              <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-pink-brand/15 border-2 border-pink-brand flex items-center justify-center group-hover:scale-110 transition-transform">
                <MapPin size={28} className="text-pink-brand" />
              </div>
              <h3 className="text-white font-bold text-lg mb-2 leading-tight">{c.nome}</h3>
              <p className="text-white/65 text-sm mb-3">{c.indirizzo}</p>
              {c.tipo && (
                <span className="inline-block bg-pink-brand/20 border border-pink-brand/40 text-pink-brand text-xs font-bold px-3 py-1 rounded-full uppercase">{c.tipo}</span>
              )}
            </div>
          ))}
        </div>
        {note && (
          <div className="mt-8 flex items-center justify-center gap-2 text-white/70 text-sm">
            <Clock size={16} />
            <span>{note}</span>
          </div>
        )}
      </div>
    </section>
  );
}
